import React, { useState } from "react";
import {
  Box,
  Drawer,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { CustomButtonContained, CustomButtonOutline } from "../shared/utils/CustomButton";
import MenuIcon from "@mui/icons-material/Menu";
import useResponsive from "../shared/utils/Responsive";
import { Constants, Page_Padding } from "../shared/constants";
import { AiFillAndroid, AiFillApple } from "react-icons/ai";
import { proSkillUrl } from "./Footer";

const Navbar = () => {
  const isSmallScreen = useResponsive("lg")
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const toggleDrawer = (newOpen) => () => setOpen(newOpen);
  const menuItems = [
    { text: "Courses", link: "/Courses", description: "Explore our latest courses" },
    { text: "Events", link: "/Events", description: "Explore our latest events" },
    { text: "My Skill Pro", link:proSkillUrl, description: "" },
    { text: "On Boarding", link: "/Apartmentonboarding", description: "Onboard with us quickly" },
    { text: "About Us", link: "/About", description: "Know more about who we are" },
    { text: "Contact Us", link: "/ContactUs", description: "Connect with us" },

  ];

  const RenderMenuList = () => (

    <List sx={{ display: "flex", flexDirection: isSmallScreen ? "column" : "row", gap: 0.5 }}>
      {menuItems.map((item, index) => (
        <ListItem key={index} sx={{ width: "auto" }}>
          <Link to={item.link} style={{ textDecoration: "none", color: "inherit" }}
              target={item.link === proSkillUrl ? "_blank" : "_self"} 
              rel={item.link === proSkillUrl ? "noopener noreferrer" : ""}
          >
            <Typography variant="body2" color={location.pathname === item.link ? "red.main" : "inherit"}>{item.text}</Typography>
          </Link>
        </ListItem>
      ))}
    </List>
  );


  const MiddleList = () => {
    return (
      <List sx={{ width: "100%", borderRadius: 2 }}>
        {menuItems.map((item, index) => (
          <ListItem
            key={index}
            button
            component={Link}
            to={item.link}
            sx={{ borderBottom: "1px solid #E5E5E5", flexDirection: "column", py: 1.5 }}
          >
            <ListItemText primary={<Typography variant="h6" fontSize={"18px"} textAlign={"center"}>{item.text}</Typography>} />
            {item.description && (
              <Typography variant="body2" fontSize={"12px"} sx={{ color: "grey.200", }} textAlign={"center"}>
                {item.description}
              </Typography>
            )}
          </ListItem>
        ))}
      </List>
    );
  };

  const DrawerList = () => (
    <Box sx={{ width: "300px" ,display:"flex",flexDirection:"column",justifyContent:"space-between",minHeight:"100vh",pb:2 }} role="presentation" onClick={toggleDrawer(false)}>
      <Grid2
        container
        sx={{
          backgroundImage: `linear-gradient(109.92deg, rgba(0, 0, 0, 0) -18.13%, rgba(0, 0, 0, 0.8) 95.24%), url(${Constants.customImages.SidebarImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "200px", // Adjust height as needed
          position: "relative",
          px: "20px"

        }}
      >
        <Grid2 children xs={12} sx={{ position: "relative", zIndex: 1, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <Typography variant="body1" textAlign={"center"} color="primary.main" gutterBottom>
            Ready to explore? Log in and let’s go!"
          </Typography>
          <CustomButtonContained buttonText="Log In" />
        </Grid2>
      </Grid2>
      <MiddleList />
      <Box display="flex" justifyContent="center"  alignItems={"center"} flexDirection={"column"} >
      <img src={Constants.customImages.SiblingPlaying} width={"40%"}/>  
        <Box mt={1}>
          <Typography variant="body1" gutterBottom>
            Available On
          </Typography>
          <Box display="flex" gap={1} justifyContent={"center"}>
            <AiFillAndroid style={{
              fontSize: "30px",
              color: "#DC143C",
            }} />
            <AiFillApple style={{
              fontSize: "30px",
              color: "#DC143C",
            }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      {!isSmallScreen && (<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 1, px: Page_Padding }}>
        <Link to={'/'}><img src={Constants.customImages.Logo} alt="logo" width={"200px"} height={"100px"} /></Link>
        <RenderMenuList />
        <Box display="flex" gap={2}>
          <CustomButtonContained buttonText="Sign Up" />
          <CustomButtonOutline buttonText="Log In" />
        </Box>



      </Box>
      )}
      {isSmallScreen && (
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", bgcolor: "primary.main", position: "sticky", top: 0, zIndex: 1000,px:1 }}>

          <IconButton onClick={toggleDrawer(true)}>
            <MenuIcon sx={{ color: "#000", fontSize: "20px" }} />
          </IconButton>
          <Link to={'/'}><img src={Constants.customImages.Logo} alt="logo" width={"100px"} height={"70px"} /></Link>    
        </Box>
      )}


      <Drawer open={open} onClose={toggleDrawer(false)}>
        <DrawerList />
      </Drawer>
    </>
  );
};

export default Navbar;
